import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { getOrderBookRequest, getOrderBookSpreadsRequest, getTradesRequest } from "./requests";
import {
  IOrderBookParams,
  IOrderBookResponse,
  IOrderBookSpreadsParams,
  IOrderBookSpreadsResponse,
  ITradesParams,
  ITradesResponse,
} from "./types";

export const useGetTrades = (
  symbol: string,
  params: ITradesParams,
  options?: Omit<UseQueryOptions<ITradesResponse[], Error>, "queryKey">
) => {
  return useQuery<ITradesResponse[], Error>({
    queryKey: ["market-trades", symbol, params?.limit, params?.chainId, params?.marketAddress],
    queryFn: () => getTradesRequest(symbol, params),
    ...(options || {}),
  });
};

export const useGetOrderBook = (
  symbol: string,
  params: IOrderBookParams,
  options?: Omit<UseQueryOptions<IOrderBookResponse, Error>, "queryKey">
) => {
  return useQuery<IOrderBookResponse, Error>({
    queryKey: [
      "market-order-book",
      symbol,
      params?.limit,
      params?.spreadValueInPrice,
      params?.chainId,
      params?.marketAddress,
    ],
    queryFn: () => getOrderBookRequest(symbol, params),
    staleTime: 5000,
    ...(options || {}),
  });
};

export const useGetOrderBookSpreads = (
  params: IOrderBookSpreadsParams,
  options?: Omit<UseQueryOptions<IOrderBookSpreadsResponse, Error>, "queryKey">
) => {
  return useQuery<IOrderBookSpreadsResponse, Error>({
    queryKey: ["market-order-book-spreads", params?.indexToken, params?.chainId],
    queryFn: () => getOrderBookSpreadsRequest(params),
    staleTime: 60_000,
    ...(options || {}),
  });
};

// export const useLoginMutation = () => {
//   return useMutation<ILoginResponse, IAxiosResponse, string>({
//     mutationKey: [KEYS.AUTH_LOGIN],
//     mutationFn: loginRequest,
//   })
// }

// export const useLogoutMutation = () => {
//   return useMutation<string, IAxiosResponse>({
//     mutationKey: [KEYS.AUTH_LOGOUT],
//     mutationFn: logoutRequest,
//   })
// }
